let ficheSelect = document.getElementById('fiche-select');
ficheSelect.addEventListener('change', () => {
  window.location = ficheSelect.value;
});



// WEBPACK FOOTER //
// ./resources/assets/js/includes/c-et-fr-droits.js